module.exports = __webpack_require__.p + "a88926f9389d1c36ddc5ae5ee6870189.jpg";